export default {
  namespaced: true,
  state: {
    managementUrl: `/api/user/management`,
    userUrl: `/api/user`,
    userList: [],
  },
  getters: {},
  mutations: {
    setUserList: (state, data) => {
      state.userList = data;
    },
  },
  actions: {
    async createUser({ commit, state }, data) {
      const { email, serviceType, advertiserId } = data;
      try {
        let res = await axios.post(`${state.managementUrl}/create`, data);
      } catch (e) {
        throw e;
      }
    },
    async confirmSignedUpUser({ commit, state }, data) {
      try {
        let res = await axios.post(`/api/confirm_user`, data);
      } catch (e) {
        throw e;
      }
    },
    async signUp({ commit, state }, data) {
      try {
        let res = await axios.post(`/api/sign_up`, data);
      } catch (e) {
        throw e;
      }
    },
    async getUserList({ commit, state }, data) {
      try {
        let res = await axios.get(`${state.managementUrl}/user_list`);
        commit("setUserList", res.data.user_list);
      } catch (e) {
        throw e;
      }
    },
    async resendInvite({ commit, state }, data) {
      try {
        let res = await axios.post(
          `${state.managementUrl}/resend_invite`,
          data
        );
      } catch (e) {
        throw e;
      }
    },
    async editUser({ commit, state }, data) {
      try {
        let res = await axios.put(`${state.managementUrl}/edit`, data);
      } catch (e) {
        throw e;
      }
    },
  },
};
